import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export function ConfirmDialog({
  open, onOpenChange, title, description, details, confirmLabel = "Potwierdź", danger, onConfirm, loading, testId,
  requireReason = false, reasonValue = "", onReasonChange, reasonLabel = "Powód (wymagany)", reasonPlaceholder = "Podaj powód tej decyzji",
}) {
  const reasonOk = !requireReason || (reasonValue || "").trim().length >= 3;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid={testId}>
        <DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
        <DialogDescription className="sr-only">Okno potwierdzenia akcji administracyjnej.</DialogDescription>
        <div className="space-y-3">
          {description && <p className="text-sm text-brand-sec">{description}</p>}
          {details && (
            <div className="rounded-card border border-brand-line bg-brand-bg/50 p-3 text-sm text-brand-text">
              {details}
            </div>
          )}
          {requireReason && (
            <div>
              <label className="mb-1 block text-xs font-semibold text-brand-sec">{reasonLabel}</label>
              <textarea
                data-testid={testId ? `${testId}-reason` : undefined}
                value={reasonValue}
                onChange={(e) => onReasonChange?.(e.target.value)}
                rows={3}
                placeholder={reasonPlaceholder}
                className="w-full rounded-field border border-brand-line bg-brand-bg p-2.5 text-sm text-brand-text outline-none focus:border-brand-accent/60"
              />
              {!reasonOk && <p className="mt-1 text-xs text-amber-300">Powód jest wymagany (min. 3 znaki).</p>}
            </div>
          )}
          <p className="text-xs text-brand-muted">Operacja zostanie zapisana w dzienniku działań na kontach.</p>
          <div className="flex justify-end gap-2 pt-1">
            <button onClick={() => onOpenChange(false)} className="h-10 rounded-field border border-brand-line px-4 text-sm text-brand-sec hover:text-brand-text">
              Anuluj
            </button>
            <button
              data-testid={testId ? `${testId}-confirm` : undefined}
              onClick={onConfirm}
              disabled={loading || !reasonOk}
              className={`h-10 rounded-field px-5 text-sm font-semibold disabled:opacity-60 ${danger ? "bg-red-500 text-white" : "bg-brand-accent text-brand-on"}`}
            >
              {loading ? "Przetwarzanie…" : confirmLabel}
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
